import React, {useEffect, useRef} from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import Navbar from '../../../components/Navbar';
import {deriveDisplayName, getCurrentUnitLink} from '../../../utils';
import AccessCard from '../components/AccessCard';
import {deriveUnitName} from '../../../utils/deriveDisplayName';
import Container from '../../../components/Container';
import {useSelector} from 'react-redux';
import {RootStore} from '../../../redux/store';

const IDCard = ({navigation}) => {
  const mountedAtRef = useRef(Date.now());
  const unitPeopleLink = getCurrentUnitLink();
  const person = useSelector((state: RootStore) => state?.auth.user);

  useEffect(() => {
    console.log('IDCard mounted in', Date.now() - mountedAtRef.current, 'ms');
  }, []);

  if (!unitPeopleLink) {
    return (
      <Container>
        <Navbar navigation={navigation} title="My ID Card" />
        <View style={styles.emptyState}>
          <Text style={styles.emptyStateText}>
            No default unit is selected yet.
          </Text>
        </View>
      </Container>
    );
  }

  const personProfilePicture = person?.profilePicture
    ? `data:image/jpeg;base64,${person?.profilePicture}`
    : 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/default-avatar.png';
  const personType = unitPeopleLink?.peopleType?.name;
  const unitPeopleLinkName = deriveDisplayName(unitPeopleLink)?.toUpperCase();
  const personName = deriveDisplayName(unitPeopleLink?.person)?.toUpperCase();
  const unitDisplayName = !!unitPeopleLink?.unit?.unitDisplay
    ? unitPeopleLink.unit.unitDisplay
    : deriveUnitName(unitPeopleLink);

  return (
    <Container>
      <Navbar navigation={navigation} title="My ID Card" />
      <ScrollView>
        <AccessCard
          personProfilePicture={personProfilePicture}
          unitPeopleLinkName={unitPeopleLinkName}
          personName={personName}
          personType={personType}
          allowedInToday={unitPeopleLink.dateFrameDay?.allowedToday}
          id={unitPeopleLink.person.id}
          unitDisplay={unitDisplayName}
          siteName={unitPeopleLink?.unit?.site?.name}
          buildingName={unitPeopleLink?.unit?.building?.name}
          communityName={unitPeopleLink?.unit?.community?.name}
          unitStatus={unitPeopleLink?.unit?.status}
        />
      </ScrollView>
    </Container>
  );
};

export default IDCard;

const styles = StyleSheet.create({
  emptyState: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
  },
  emptyStateText: {
    fontSize: 16,
    textAlign: 'center',
  },
});
